<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner color="primary" [hidden]="!showSpinner"></fab-loading-spinner>

<div id="header-container">
  <h1 class="title">Manage Architecture Deviances</h1>
</div>
<div>
  <mat-card appearance="outlined" class="default-padding">
    <mat-card-title>Program Codes</mat-card-title>
    <div class="gfs-table" *ngIf="prgmCodeList.length > 0">
      <ag-grid-angular
        style="height: 100%; width:100%;"
        class="ag-theme-quartz"
        [rowData]="prgmCodeList"
        [columnDefs]="columnDefs"
        [autoSizeStrategy]="autoSizeStrategy"
        [rowHeight]="50"
      ></ag-grid-angular>
    </div>
    <div *ngIf="prgmCodeList.length === 0">No Program Codes with Arch Deviances</div>
  </mat-card>
</div>

